import { Crumb } from '../components/Shared/Breadcrumb/Breadcrumb';

// ----------------------------------------------------------------------------
// https://developers.google.com/search/docs/appearance/structured-data/breadcrumb
// Breadcrumb structured data base URL
export const BREADCRUMB_SD_BASE_URL = 'https://vmf.com';

// Breadcrumb structured data - single breadcrumb trail
export const breadcrumbStructuredData = (breadcrumbData: Crumb[]) => {
  // Breadcrumb structured data is not valid if there are no crumbs.
  // Return an empty object to avoid errors in JSON-LD.
  if (!breadcrumbData || breadcrumbData.length === 0) {
    return undefined;
  }

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbStructuredDataListItems(breadcrumbData),
  };

  return breadcrumbSchema;
};

export interface BreadcrumbListItem {
  '@type': 'ListItem';
  position: number;
  name: string;
  item?: string;
}

function breadcrumbStructuredDataListItems(breadcrumbData: Crumb[]) {
  let data = [];
  breadcrumbData?.forEach((crumb, i) => {
    const listItem: any = {
      '@type': 'ListItem',
      position: i + 1,
      name: crumb.text,
    };
    // Only add URL if it exists and is not the last crumb.
    if (crumb?.url && i < breadcrumbData.length - 1) {
      // Full URLs are used as-is. Tests for http or https.
      // Relative paths get a leading / if missing and are prefixed with BREADCRUMB_SD_BASE_URL.
      let url = crumb.url;
      if (!/^https?:\/\//i.test(url)) {
        if (!url.startsWith('/')) {
          url = '/' + url;
        }
        url = BREADCRUMB_SD_BASE_URL + url;
      }
      listItem.item = url;
    }
    data.push(listItem);
  });

  return data;
}

// ----------------------------------------------------------------------------
